import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-responsive-modal'
import { connectModal, hide } from 'redux-modal'
import { useDispatch } from 'react-redux'
import styled from 'styled-components/macro'
import LightButton from 'components/ui/LightButton'
import DOMPurify from 'dompurify'

const purify = DOMPurify(window)

const CloseIcon = styled.i`
  font-size: 20px;
  color: #ffffff;
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 10px;
  cursor: pointer;
`
const ModalContent = styled.div`
  padding-top: 20px;
  margin-top: 10px;
  font-family: 'Open Sans';
  font-size: 14px;
  line-height: 20px;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.3;
  }
  ul li {
    margin-left: 20px;
  }
  a {
    font-size: 14px;
    color: #ffffff;
    text-decoration: underline;
  }
  p {
    margin-bottom: 10px;
  }
`

const ButtonContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
  max-width: 300px;
`
const modalStyles = {
  modal: {
    backgroundColor: '#003399',
    color: '#ffffff',
    minWidth: '250px',
    borderRadius: '4px',
    boxShadow:
      '0 16px 24px 2px rgba(0,0,0,0.14), 0 6px 30px 5px rgba(0,0,0,0.12), 0 8px 10px 0 rgba(0,0,0,0.2)'
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.15)'
  },
  closeButton: {}
}

function InfoModal({ show, message }) {
  const dispatch = useDispatch()
  const modalRef = useRef()
  useEffect(() => {
    if (show) {
      setTimeout(() => {
        const el = modalRef.current.container.childNodes[0]
        el.scrollTop = 0
      })
    }
  }, [show])
  return (
    <div>
      <Modal
        styles={modalStyles}
        open={show}
        showCloseIcon={false}
        onClose={() => {
          dispatch(hide('infoModal'))
        }}
        center
        ref={modalRef}
      >
        <CloseIcon
          onClick={() => {
            dispatch(hide('infoModal'))
          }}
          className="far fa-times"
        />
        <ModalContent>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: purify.sanitize(message)
            }}
          />
        </ModalContent>
        <ButtonContainer>
          <LightButton
            size="medium"
            onClick={() => {
              dispatch(hide('infoModal'))
            }}
          >
            OK
          </LightButton>
        </ButtonContainer>
      </Modal>
    </div>
  )
}

InfoModal.propTypes = {
  show: PropTypes.bool,
  message: PropTypes.string
}

export default connectModal({ name: 'infoModal' })(InfoModal)
